import { typeStateCategories } from "../Layout"
import { Chatting } from "./Chatting";
import { LiveCam } from "./LiveCam";
import { Videos } from "./Videos";

interface PreviewControlProps extends typeStateCategories {
    selectedShortName: string;
}

export const PreviewControl = (props: PreviewControlProps) => {
    const { state, selectedShortName } = props;
    const [category] = state;
    return (
        <>
            {category === 'videos' && <Videos shortName={selectedShortName} />}
            {category === 'livecams' && <LiveCam />}
            {category === 'chatting' && <Chatting shortName={selectedShortName} />}
        </>
    )
}